const generateDisruptionOptions = (): { id: string; label: string; value: string }[] => {
    const results: { id: string; label: string; value: string }[] = []

    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
            const h = hour.toString().padStart(2, '0')
            const m = minute.toString().padStart(2, '0')
            const value = `${h}:${m}`
            results.push({ id: crypto.randomUUID(), label: value, value })
        }
    }

    return results
}

export const generateDisruptionTimeOptions = () => {
    return generateDisruptionOptions()
}
